export enum TableViewType {
  EVENT = "EVENT",
  GUEST = "GUEST",
  EMAIL_SENT = "EMAIL_SENT",
  CHECK_IN = "CHECK_IN",
  ACTION_LOG = "ACTION_LOG",
  SPEAKER = "SPEAKER",
  SPONSOR = "SPONSOR",
}
